<template>
  <div class="lgn-page">
    <!-- ============ PANEL KIRI: IDENTITAS INSTANSI ============ -->
    <aside class="lgn-brand">
      <svg class="lgn-waves" viewBox="0 0 1440 320" preserveAspectRatio="none" aria-hidden="true">
        <path fill="rgba(255,255,255,0.07)"
          d="M0,224L48,208C96,192,192,160,288,170.7C384,181,480,235,576,234.7C672,235,768,181,864,160C960,139,1056,149,1152,176C1248,203,1344,245,1392,266.7L1440,288L1440,320L0,320Z" />
        <path fill="rgba(255,255,255,0.05)"
          d="M0,256L60,245.3C120,235,240,213,360,218.7C480,224,600,256,720,261.3C840,267,960,245,1080,224C1200,203,1320,181,1380,170.7L1440,160L1440,320L0,320Z" />
      </svg>

      <div class="lgn-brand-inner">
        <div class="lgn-brand-head">
          <div class="lgn-header-wrappers">
            <a class="lgn-logo" href="https://e-sea.kkp.go.id/perizinan">
              <img src="./assets/images/logo_new_v3.png" alt="logo" loading="lazy" />
            </a>

            <span class="lgn-org text-center" data-setting="app_name">
              DIREKTORAT PEMANFAATAN RUANG KOLOM PERAIRAN DAN DASAR LAUT
              <br />
              DIREKTORAT JENDERAL PENATAAN RUANG LAUT
            </span>
          </div>
        </div>

        <div class="lgn-hero">
          <div class="lgn-hero-card">
            <img class="lgn-hero-img" src="./assets/images/gambar.png" alt="logo-img" loading="lazy" />
          </div>
        </div>
      </div>
    </aside>

    <!-- ============ PANEL KANAN: FORM REGISTER ============ -->
    <section class="lgn-panel">
      <div class="lgn-card">
        <header class="lgn-head">
          <h1 class="lgn-title"><span class="lgn-accent">Sign</span> Up</h1>
          <p class="lgn-sub">Selamat Datang di Halaman e-SEA</p>
        </header>

        <form class="lgn-form" novalidate @submit.prevent="checkIfRecaptchaVerified">
          <!-- NPWP -->
          <div class="lgn-field">
            <label class="lgn-label" for="npwp">NPWP</label>
            <div class="lgn-control">
              <svg class="lgn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="4" width="18" height="16" rx="2" />
                <circle cx="9" cy="10" r="2" />
                <path d="M15 8h2M15 12h2M7 16h10" />
              </svg>
              <input type="text" v-model="form.npwp" v-mask="'##.###.###.#-###.####'" class="lgn-input"
                :class="{ 'is-error': errors.has('NPWP') }" id="npwp"
                placeholder="Masukkan NPWP Instansi/Perusahaan/Perorangan" name="NPWP"
                v-validate="'required|valid_npwp'" :aria-invalid="errors.has('NPWP') ? 'true' : 'false'"
                aria-describedby="npwp-error" />
            </div>
            <small class="lgn-error" id="npwp-error" role="alert" v-if="errors.has('NPWP')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('NPWP') }}
            </small>
          </div>

          <!-- Nama -->
          <div class="lgn-field">
            <label class="lgn-label" for="nama">Nama</label>
            <div class="lgn-control">
              <svg class="lgn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="4" y="2" width="16" height="20" rx="2" />
                <path d="M9 22v-4h6v4" />
                <path d="M8 6h.01M12 6h.01M16 6h.01M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01" />
              </svg>
              <input type="text" v-model="form.nama" class="lgn-input" :class="{ 'is-error': errors.has('Nama') }"
                id="nama" placeholder="Masukkan Nama Instansi/Perusahaan/Perorangan" name="Nama" v-validate="'required'"
                :aria-invalid="errors.has('Nama') ? 'true' : 'false'" aria-describedby="nama-error" />
            </div>
            <small class="lgn-error" id="nama-error" role="alert" v-if="errors.has('Nama')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('Nama') }}
            </small>
          </div>

          <!-- Kategori Pengguna -->
          <div class="lgn-field">
            <span class="lgn-label" id="kategori-label">Kategori Pengguna</span>
            <div class="lgn-seg" :class="{ 'is-error': errors.has('Kategori Pengguna') }" role="radiogroup"
              aria-labelledby="kategori-label">
              <input type="radio" class="lgn-seg-input" name="Kategori Pengguna" id="opt_pemerintah" value="pemerintah"
                v-model="form.tipe_pemohon" autocomplete="off" v-validate="'required'" />
              <label class="lgn-seg-item" for="opt_pemerintah">
                <svg class="lgn-seg-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <line x1="3" y1="22" x2="21" y2="22" />
                  <line x1="6" y1="18" x2="6" y2="11" />
                  <line x1="10" y1="18" x2="10" y2="11" />
                  <line x1="14" y1="18" x2="14" y2="11" />
                  <line x1="18" y1="18" x2="18" y2="11" />
                  <polygon points="12 2 20 7 4 7" />
                </svg>
                <span class="lgn-seg-text">Pemerintah</span>
                <svg class="lgn-seg-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </label>

              <input type="radio" class="lgn-seg-input" name="Kategori Pengguna" id="opt_swasta" value="swasta"
                v-model="form.tipe_pemohon" autocomplete="off" v-validate="'required'" />
              <label class="lgn-seg-item" for="opt_swasta">
                <svg class="lgn-seg-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
                <span class="lgn-seg-text">Swasta/Pelaku Usaha</span>
                <svg class="lgn-seg-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </label>
            </div>
            <small class="lgn-error" id="kategori-error" role="alert" v-if="errors.has('Kategori Pengguna')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('Kategori Pengguna') }}
            </small>
          </div>

          <!-- Email -->
          <div class="lgn-field">
            <label class="lgn-label" for="email">Email</label>
            <div class="lgn-control">
              <svg class="lgn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="m3 7 9 6 9-6" />
              </svg>
              <input type="text" v-model="form.email" class="lgn-input" :class="{ 'is-error': errors.has('Email') }"
                id="email" placeholder="Masukkan email Instansi/Perusahaan/Perorangan" name="Email"
                v-validate="'required|email'" autocomplete="email"
                :aria-invalid="errors.has('Email') ? 'true' : 'false'" aria-describedby="email-error" />
            </div>
            <small class="lgn-error" id="email-error" role="alert" v-if="errors.has('Email')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('Email') }}
            </small>
          </div>

          <!-- Password -->
          <div class="lgn-field">
            <label class="lgn-label" for="password">Password</label>
            <div class="lgn-control">
              <svg class="lgn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="4" y="11" width="16" height="10" rx="2" />
                <path d="M8 11V8a4 4 0 0 1 8 0v3" />
              </svg>
              <input :type="showPassword ? 'text' : 'password'" v-model="form.password" class="lgn-input lgn-input--eye"
                :class="{ 'is-error': errors.has('Password') }" id="password" placeholder="Password" name="Password"
                v-validate="'required|strong_password'" autocomplete="new-password"
                :aria-invalid="errors.has('Password') ? 'true' : 'false'" aria-describedby="password-error" />
              <button class="lgn-eye" type="button" id="btn-show" @click="toggleShow"
                :aria-label="showPassword ? 'Sembunyikan password' : 'Tampilkan password'"
                :aria-pressed="showPassword ? 'true' : 'false'">
                <svg v-if="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                  <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
            <small class="lgn-error" id="password-error" role="alert" v-if="errors.has('Password')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('Password') }}
            </small>
          </div>

          <!-- reCAPTCHA -->
          <div class="lgn-recaptcha">
            <VueRecaptcha @verify="markRecaptchaAsVerified" sitekey="6LcWcyopAAAAAMIHDH7BVEQuyt-Qw1T0C99UG6jz">
            </VueRecaptcha>
          </div>
          <p class="lgn-alert" role="alert" v-if="pleaseTickRecaptchaMessage">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <strong>{{ pleaseTickRecaptchaMessage }}</strong>
          </p>

          <!-- Tombol -->
          <button type="submit" class="lgn-btn lgn-btn--primary" :disabled="isLoading">
            <template v-if="!isLoading">Register</template>
            <Loader v-else />
          </button>

          <div class="lgn-links">
            <p class="lgn-links-row">
              <span>Anda sudah memiliki Akun?</span>
              <a href="/login" class="lgn-link"> Login</a>
            </p>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<style src="./assets/css/hope-ui.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/pro.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/custom.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/dark.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/customizer.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/rtl.min.css?v=2.0.0" lang="css" />
<!-- Gaya halaman register (desain baru). Kelas berawalan lgn- agar tidak bentrok dengan CSS tema di atas. -->
<style src="./Register.css" lang="css" scoped />
<!-- Library Bundle Script -->
<script src="./assets/js/core/libs.min.js"></script>
<!-- Plugin Scripts -->
<!-- <style src="./assets/css/custom/login-custom.css" lang="css" /> -->
<!-- Slider-tab Script -->
<script src="./assets/js/plugins/slider-tabs.js"></script>
<!-- Lodash Utility -->
<script src="./assets/vendor/lodash/lodash.min.js"></script>
<!-- Utilities Functions -->
<script src="./assets/js/iqonic-script/utility.js"></script>
<!-- Settings Script -->
<script src="./assets/js/iqonic-script/setting.js"></script>
<!-- Settings Init Script -->
<script src="./assets/js/setting-init.js"></script>
<!-- External Library Bundle Script -->
<script src="./assets/js/core/external.min.js"></script>
<!-- Widgetchart Script -->
<script src="./assets/js/charts/widgetcharts.js?v=2.0.0" defer></script>
<!-- Dashboard Script -->
<script src="./assets/js/charts/dashboard.js?v=2.0.0" defer></script>
<script src="./assets/js/charts/alternate-dashboard.js?v=2.0.0" defer></script>
<!-- Hopeui Script -->
<script src="./assets/js/hope-ui.js?v=2.0.0" defer></script>
<script src="./assets/js/hope-uipro.js?v=2.0.0" defer></script>
<script src="./assets/js/sidebar.js?v=2.0.0" defer></script>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { Validator } from 'vee-validate'
import axios from 'axios'
import Swal from 'sweetalert2'
import Loader from '../../components/Loader/Loader'

export default {
  components: { VueRecaptcha, Loader },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      showPassword: false,
      form: {
        npwp: '',
        nama: '',
        tipe_pemohon: '',
        email: '',
        password: '',
        role: 'pemohon',
      },
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      isLoading: false,
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword
    },
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    async checkIfRecaptchaVerified() {
      await this.$validator.validateAll()
      if (this.$validator.errors.any()) return

      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        return true
      }
      this.register()
    },
    async register() {
      try {
        this.isLoading = true
        const res = await axios.post(
          `${this.baseapi}api/auth/signup`,
          this.form,
        )
        await Swal.fire('Berhasil', res.data.message, 'success')
        this.$router.push('/login')
      } catch (error) {
        if (error.status >= 500) {
          Swal.fire('Error', 'Sedang terjadi kendala pada Server', 'error')
        } else {
          Swal.fire(
            'Register Gagal',
            error.response?.data?.message || 'Terjadi kesalahan saat register',
            'warning',
          )
        }
      } finally {
        this.isLoading = false
      }
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: (fieldName) => `Format email tidak sesuai`,
          strong_password: (fieldName) =>
            `${fieldName} harus memiliki minimal 8 karakter, termasuk huruf besar, huruf kecil, angka, dan simbol.`,
          valid_npwp: (fieldName) => `Format NPWP tidak sesuai`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  created() {
    Validator.extend('strong_password', {
      validate: (value) => {
        return (
          /[A-Z]/.test(value) &&
          /[a-z]/.test(value) &&
          /[0-9]/.test(value) &&
          /[^A-Za-z0-9]/.test(value) &&
          value.length >= 8
        )
      },
    })
    Validator.extend('valid_npwp', {
      validate: (value) => {
        return /^\d{2}\.\d{3}\.\d{3}\.\d-\d{3}\.\d{3,4}$/.test(value)
      },
    })
  },
}
</script>